import universal from 'react-universal-component';

export default universal(() => import('./Player'));



// WEBPACK FOOTER //
// ./src/app/views/Player/index.js